var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
ConfirmationBanner.BelowNavView = function (superClass) {
  extend(BelowNavView, superClass);
  function BelowNavView() {
    return BelowNavView.__super__.constructor.apply(this, arguments);
  }
  BelowNavView.defaultFadeout = 1500;
  BelowNavView.fadeInTime = 250;
  BelowNavView.fadeOutTime = 500;
  BelowNavView.defaultAfter = '#main-header-container';
  BelowNavView.prototype.className = 'bootstrap';
  BelowNavView.prototype.jstTemplate = "confirmation_banner/templates/below_nav_view";
  BelowNavView.prototype.events = {
    "click *[data-action]": "actionWasClicked"
  };
  BelowNavView.prototype.initialize = function (options) {
    this.mode = options.mode;
    this.message = options.message;
    this.actions = options.actions || {};
    this.afterElement = $(options.after || this.constructor.defaultAfter);
    this.fadeout = options.fadeout;
    if (this.fadeout === true) {
      this.fadeout = this.constructor.defaultFadeout;
    }
    if (this.mode === 'success') {
      this.bannerClass = 'bg-success';
      return this.iconClass = 'fa-check-circle';
    } else if (this.mode === 'warning') {
      this.bannerClass = 'bg-warning';
      return this.iconClass = 'fa-exclamation-triangle';
    }
  };
  BelowNavView.prototype.actionWasClicked = function (ev) {
    this.actions[$(ev.target).data("action")]();
    if (this.fadeout) {
      return this.close();
    }
  };
  BelowNavView.prototype.render = function () {
    this.$el.html(JST[this.jstTemplate]({
      message: this.message,
      actions: _.keys(this.actions),
      bannerClass: this.bannerClass,
      iconClass: this.iconClass
    }));
    this.afterElement.after(this.$el).fadeIn(this.constructor.fadeInTime);
    if (this.fadeout) {
      return this.$el.delay(this.fadeout).fadeOut(this.constructor.fadeOutTime);
    }
  };
  BelowNavView.prototype.close = function () {
    return this.$el.fadeOut(ConfirmationBanner.BelowNavView.fadeOutTime);
  };
  return BelowNavView;
}(Backbone.View);
window.extend = extend;
window.hasProp = hasProp;